<template>
    <div style="display: flex; flex-direction: column; justify-content: flex-start;height: 100%;" loading="p_loading">
    </div>
  </template>
  
  <script>
  import helpOther from '../../components/helpOther.vue';
  import { resetRouter, router } from '@/router';
  
  export default {
    data() {
      return {
        p_loading: false,
        dataInfo: null,
        token:"",
        shop: null,
        user: null,
        routerList: [],
        loginCheck: false,
        loadingInstance: null,
        is_choose_identity: 0,
      };
    },
    mounted(){
      const query = this.$route.query
     // 保存token并执行自动登录
        this.token = query.token
        this.shop = query.shop
        this.user = query.user
        this.$store.commit('saveShopStatus', query.shop.status)
        this.$store.commit('saveShopData', query.shop)
        this.token_login()
    },   
    methods: {
      token_login() {
        const query = this.$route.query
        this.token = query.login_token
        this.shop = query.shop
        this.user = query.user
        this.$store.commit('saveShopStatus', query.shop.status)
        localStorage.setItem('logintoken_shop', this.token)
        localStorage.setItem('userdata_shop', this.user)
        localStorage.setItem('c_shopId', this.shop.shop_id);
        this.$store.commit('saveShopData', this.shop) 
        this.getPermissionList()
      },
      // 获取权限列表
      getPermissionList(){
        this.p_loading=true
        this.$get(this.$api.permissionList).then(res => {
          if (res.status == 200) {
            localStorage.setItem('menuList', JSON.stringify(res.data))
            resetRouter()
            this.routerList=[]
            this.handlerRouters(res.data)
            this.getRuleIds()
          }
        })
      },
      // 获取当前帐号的权限ids
      getRuleIds(){
        this.p_loading=false
        this.$get(this.$api.ruleIds).then(res => {
          if (res.status == 200) {
            localStorage.setItem('ruleIds', JSON.stringify(Object.values(res.data)))
            if (this.is_choose_identity != 1) {
              this.$router.push({
                path: "/statistics"
              })
            } else {
              this.loginCheck = true;
            }
          }
        }).finally(()=>{
          if(this.loadingInstance){
            this.loadingInstance.close()
          }
        })
      },
      // 处理路由集合
      handlerRouters(list){
        list.forEach(item => {
          if(item.component&&item.path){
            this.routerList.push({path:item.path,name:item.title,'component':() => import(`@/views${item.component}`),meta:{requireAuth: true}})
          }
          if(item.child.length>0){
            this.handlerRouters(item.child)
          }
        })
      },
      openWenDang(){
        window.open('https://www.yuque.com/bocai007/zgqd2m/rskz8lltid9k0d2d','_blank')
      },
      gowhere(url,index,rule_id){
        if(JSON.parse(localStorage.getItem('ruleIds')).indexOf(rule_id)>-1){
          this.$router.push({
            path:url,
            query:{
              index:index
            }
          })
        }else{
          this.$message.error('您的角色暂无该权限');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  >>> .el-input-group__append {
    padding: 0 10px;
  }
  .cardbox{
    padding: 16px;
    border: 1px solid #ecedef;
    box-shadow: 0px 0px 10px #ecedef;
    border-radius: 10px;
  }
  .title{
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 10px;
  }
  .title span{
    font-size: 12px;
    color: darkgrey;
    padding-left: 20px;
    font-weight: normal;
  }
  .dbbox{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .db_once{
    width: 33.33%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .db_once img{
    width: 42px;
    height: 40px;
    margin-right: 10px;
  }
  .db_once div h1{
    font-size: 26px;
    margin: 0;
  }
  .db_once div p{
    font-size: 12px;
    color: gray;
    margin: 0;
  }
  .sjbox{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .sj_once{
    width: 25%;
    padding: 20px 0;
  }
  .sj_once h1{
    font-size: 20px;
    margin: 0;
  }
  .sj_once p{
    font-size: 12px;
    color: gray;
    margin: 0;
  }
  .phbbox{
    display: flex;
    justify-content: space-between;
  }
  .oncetitle{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .oncetitle span{
    font-size: 12px;
    color: #333333;
    width: 33.33%;
    margin-bottom: 4px;
  }
  .oncelist{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 4px;
  }
  .oncelist div{
    width: 33.33%;
    font-size: 12px;
    color: gray;
  }
  .oncelist img{
    width: 20px;
    height: 20px;
  }
  .oncelist span{
    font-size: 12px;
    color: gray;
    width: 33.33%;
  }
  
  .wendang{
    width: 40px;
    height: 100px;
    background: white;
    border: 1px solid #ecedef;
    box-shadow: 0px 0px 10px #dadada;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: fixed;
    bottom: 70px;
    right: 10px;
    cursor: pointer;
    font-size: 14px;
    text-align: center;
    padding: 10px 0;
  }
  .wendang i{
    font-size: 20px;
    padding: 0 10px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/toLog/index.vue